import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Debug-logi vain dev-tilassa (ei avainta konsoliin)
if (process.env.NODE_ENV !== 'production') {
  console.log('Supabase URL present:', !!supabaseUrl);
  console.log('Supabase KEY present:', !!supabaseAnonKey);
}

// Tarkista että env-muuttujat ovat olemassa
let supabase = null;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ CRITICAL: Missing Supabase environment variables!');
  console.error('Required: REACT_APP_SUPABASE_URL');
  console.error('Required: REACT_APP_SUPABASE_ANON_KEY');
  console.error('Please configure these in Vercel project settings (Settings → Environment Variables).');
  console.error('After adding variables, redeploy the project.');
  // supabase pysyy null - ei luoda clientia tyhjillä arvoilla
} else {
  // Luodaan client vain jos env-muuttujat ovat olemassa
  supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: false, // Disable auto refresh to prevent unwanted token requests
      detectSessionInUrl: true,
    },
  });
}

export { supabase };
